import Cookies from 'js-cookie';

/**
 * Google翻訳のプラグイン
 *
 *
 * usage
   GOOG_TRANSLATE({ // GoogleTranslate
     GA_ID: 'UA-19412893-40',
     lang: 'ar,cy,da,de,el,en,es,fi,fr,gd,hr,id,is,it,ja,kk,ko,la,nl,pl,pt,ru,sk,sv,th,tl,tr,vi,zh-CN,zh-TW'
   })
 */

export default function GOOG_TRANSLATE() {
  const [w, d] = [window, document];

  w.addScript({'src':'//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'});

  w.googleTranslateElementInit = () => {

    $('.lang-select[data-lang="en"]').on('click', function() {
      let lang = $(this).attr('data-lang');
      w.location = $(this).attr('href');
      location.reload();
    });

    $('.lang-select[data-lang="ja"]').on('click', function() {
      Cookies.remove('googtrans');
      Cookies.remove('googtrans', { path: '/', domain: '.websapo.jp' });
      Cookies.remove('googtrans', { path: '/', domain: '.hamagasu.com' });
    });

    let google = w.google || {}
    new google.translate.TranslateElement({
      pageLanguage: 'ja',
      layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
    }, 'google_translate_element');

  };
}